import { c as _c } from "react/compiler-runtime";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import { WAVE_LABELS } from "@/helpers/waves/waves.constants";
import CommonBorderedRadioButton from "@/components/utils/radio/CommonBorderedRadioButton";
export default function CreateWaveTypeInputs(t0) {
  const $ = _c(5);
  const {
    selected,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [ApiWaveType.Chat, ApiWaveType.Rank, ApiWaveType.Approve];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const waveTypes = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      [ApiWaveType.Chat]: "Create a social hub for community discussions.",
      [ApiWaveType.Rank]: "Top-voted submissions win at a set time.",
      [ApiWaveType.Approve]: "Submissions win once they reach a vote threshold."
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const waveTypeDescriptions = t2;
  let t3;
  if ($[2] !== onChange || $[3] !== selected) {
    t3 = <div className="tw-grid tw-grid-cols-1 tw-gap-3 sm:tw-grid-cols-3 [&>div]:tw-rounded-xl [&>div]:tw-px-3 [&>div]:tw-py-3 [&>div]:tw-shadow-none [&_input]:tw-h-4 [&_input]:tw-w-4">{waveTypes.map(waveType => {
        const isSelected = selected === waveType;
        let titleColorClass = "tw-text-iron-300 group-hover:tw-text-white";
        let descriptionColorClass = "tw-text-iron-500";
        if (isSelected) {
          titleColorClass = "tw-text-white";
          descriptionColorClass = "tw-text-iron-300";
        }
        return <CommonBorderedRadioButton key={waveType} type={waveType} selected={selected} variant="subtle" onChange={onChange}><div className="tw-min-w-0 tw-whitespace-normal"><span className={`tw-flex tw-min-h-4 tw-items-center tw-text-sm tw-font-semibold ${titleColorClass}`}>{WAVE_LABELS[waveType]}</span><p className={`tw-mb-0 tw-mt-1 tw-text-xs tw-font-medium tw-leading-4 ${descriptionColorClass}`}>{waveTypeDescriptions[waveType]}</p></div></CommonBorderedRadioButton>;
      })}</div>;
    $[2] = onChange;
    $[3] = selected;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}